import type { LucideIcon } from 'lucide-react';
import {
	Activity,
	Airplay,
	AlertTriangle,
	AppWindow,
	Archive,
	ArrowRightLeft,
	Award,
	BarChart3,
	Binary,
	Blocks,
	BookOpen,
	Bot,
	BotMessageSquare,
	Boxes,
	Brain,
	Briefcase,
	Bug,
	Building,
	Building2,
	Cable,
	Calendar,
	Candy,
	CheckCircle,
	CircleDot,
	ClipboardList,
	Cloud,
	Code,
	Code2,
	Coins,
	Compass,
	Component,
	Cpu,
	Crown,
	Database,
	Factory,
	FileCode,
	FileSearch,
	FileText,
	Filter,
	Fingerprint,
	Flag,
	Folder,
	FolderOpen,
	FolderTree,
	Gamepad2,
	Gauge,
	Gem,
	Ghost,
	GitBranch,
	GitMerge,
	GitFork,
	Globe,
	Grip,
	Handshake,
	HardDrive,
	Hash,
	Heart,
	IdCard,
	Inbox,
	Infinity,
	Inspect,
	Key,
	KeyRound,
	Layers,
	LayoutDashboard,
	Library,
	Link,
	ListChecks,
	Lock,
	LockKeyhole,
	LogIn,
	Mail,
	Map,
	Megaphone,
	MessageSquare,
	Microscope,
	Monitor,
	MonitorCheck,
	Network,
	Package,
	PackageOpen,
	Palette,
	PanelLeft,
	PencilRuler,
	PieChart,
	Plug,
	PlugZap,
	PlusCircle,
	Puzzle,
	QrCode,
	Radar,
	Receipt,
	Rocket,
	Route,
	SatelliteDish,
	Scan,
	ScrollText,
	Search,
	Send,
	Server,
	Settings,
	Shield,
	ShieldAlert,
	ShieldCheck,
	ShieldPlus,
	ShoppingCart,
	Shuffle,
	Signal,
	SlidersHorizontal,
	Sparkles,
	Split,
	Sprout,
	Tag,
	Tags,
	Target,
	Terminal,
	TestTube,
	Ticket,
	Timer,
	ToggleLeft,
	Toolbox,
	TowerControl,
	Trophy,
	Unplug,
	Upload,
	User,
	UserCheck,
	UserCog,
	UserRoundCheck,
	UserSearch,
	Users,
	Wallet,
	Wand2,
	Workflow,
	Wrench,
	Zap,
} from 'lucide-react';

export type ExperienceIconKey = keyof typeof LUCIDE_REGISTRY;

export const LUCIDE_REGISTRY: Record<string, LucideIcon> = {
	'activity': Activity,
	'airplay': Airplay,
	'alert-triangle': AlertTriangle,
	'app-window': AppWindow,
	'archive': Archive,
	'arrow-right-left': ArrowRightLeft,
	'award': Award,
	'bar-chart-3': BarChart3,
	'binary': Binary,
	'blocks': Blocks,
	'book-open': BookOpen,
	'bot': Bot,
	'bot-message-square': BotMessageSquare,
	'boxes': Boxes,
	'brain': Brain,
	'briefcase': Briefcase,
	'bug': Bug,
	'building': Building,
	'building-2': Building2,
	'cable': Cable,
	'calendar': Calendar,
	'candy': Candy,
	'check-circle': CheckCircle,
	'circle-dot': CircleDot,
	'clipboard-list': ClipboardList,
	'cloud': Cloud,
	'code': Code,
	'code-2': Code2,
	'coins': Coins,
	'compass': Compass,
	'component': Component,
	'cpu': Cpu,
	'crown': Crown,
	'database': Database,
	'factory': Factory,
	'file-code': FileCode,
	'file-search': FileSearch,
	'file-text': FileText,
	'filter': Filter,
	'fingerprint': Fingerprint,
	'flag': Flag,
	'folder': Folder,
	'folder-open': FolderOpen,
	'folder-tree': FolderTree,
	'gamepad-2': Gamepad2,
	'gauge': Gauge,
	'gem': Gem,
	'ghost': Ghost,
	'git-branch': GitBranch,
	'git-merge': GitMerge,
	'github': GitFork,
	'globe': Globe,
	'grip': Grip,
	'handshake': Handshake,
	'hard-drive': HardDrive,
	'hash': Hash,
	'heart': Heart,
	'id-card': IdCard,
	'inbox': Inbox,
	'infinity': Infinity,
	'inspect': Inspect,
	'key': Key,
	'key-round': KeyRound,
	'layers': Layers,
	'layout-dashboard': LayoutDashboard,
	'library': Library,
	'link': Link,
	'list-checks': ListChecks,
	'lock': Lock,
	'lock-keyhole': LockKeyhole,
	'log-in': LogIn,
	'mail': Mail,
	'map': Map,
	'megaphone': Megaphone,
	'message-square': MessageSquare,
	'microscope': Microscope,
	'monitor': Monitor,
	'monitor-check': MonitorCheck,
	'network': Network,
	'package': Package,
	'package-open': PackageOpen,
	'palette': Palette,
	'panel-left': PanelLeft,
	'pencil-ruler': PencilRuler,
	'pie-chart': PieChart,
	'plug': Plug,
	'plug-zap': PlugZap,
	'plus-circle': PlusCircle,
	'puzzle': Puzzle,
	'qr-code': QrCode,
	'radar': Radar,
	'receipt': Receipt,
	'rocket': Rocket,
	'route': Route,
	'satellite-dish': SatelliteDish,
	'scan': Scan,
	'scroll-text': ScrollText,
	'search': Search,
	'send': Send,
	'server': Server,
	'settings': Settings,
	'shield': Shield,
	'shield-alert': ShieldAlert,
	'shield-check': ShieldCheck,
	'shield-plus': ShieldPlus,
	'shopping-cart': ShoppingCart,
	'shuffle': Shuffle,
	'signal': Signal,
	'sliders-horizontal': SlidersHorizontal,
	'sparkles': Sparkles,
	'split': Split,
	'sprout': Sprout,
	'tag': Tag,
	'tags': Tags,
	'target': Target,
	'terminal': Terminal,
	'test-tube': TestTube,
	'ticket': Ticket,
	'timer': Timer,
	'toggle-left': ToggleLeft,
	'tool': Toolbox,
	'tower-control': TowerControl,
	'trophy': Trophy,
	'unplug': Unplug,
	'upload': Upload,
	'user': User,
	'user-check': UserCheck,
	'user-cog': UserCog,
	'user-round-check': UserRoundCheck,
	'user-search': UserSearch,
	'users': Users,
	'wallet': Wallet,
	'wand-2': Wand2,
	'workflow': Workflow,
	'wrench': Wrench,
	'zap': Zap,
};

const FALLBACK_KEY = 'app-window';

export function resolveLucideIcon(key: string | undefined | null): LucideIcon {
	if (!key) return LUCIDE_REGISTRY[FALLBACK_KEY];
	const icon = LUCIDE_REGISTRY[key];
	if (icon) return icon;
	if (import.meta.env?.DEV) {
		console.warn(
			`[ExperienceIcon] Unknown icon key "${key}". ` +
			`Falling back to "${FALLBACK_KEY}". ` +
			`See experience-launcher-contract.json for approved keys.`
		);
	}
	return LUCIDE_REGISTRY[FALLBACK_KEY];
}

export function isRegistryKey(value: string | undefined | null): value is ExperienceIconKey {
	return !!value && value in LUCIDE_REGISTRY;
}
